export const getEnvironmentVar = (code: string): string | undefined => {
  return process && process.env && process.env[code] ? process.env[code] : '';
};
